import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { ContentBanner } from '@xing-com/banner';
import { IconInfo } from '@xing-com/icons';
import { spaceS, spaceXL } from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

import { useShowNotEnoughProfileError } from '../../../apollo';

export const NotEnoughProfileDataBanner: React.FC = () => {
  const [show, setShow] = useShowNotEnoughProfileError();

  const onClose = (): void => {
    setShow(false);
  };

  return (
    <Banner show={show} display="inline" handleOnClose={onClose}>
      <Content>
        <Icon width={24} height={24} />
        <BodyCopy size="small" noMargin>
          <FormattedMessage id="JOBS_SEARCH_AI_SUGGESTION_ERROR" />
        </BodyCopy>
      </Content>
    </Banner>
  );
};

const Banner = styled(ContentBanner)`
  margin-bottom: ${spaceXL};
  padding-right: 40px;
`;

const Content = styled.div`
  display: flex;
  gap: ${spaceS};
`;

const Icon = styled(IconInfo)`
  flex-shrink: 0;
`;
